import React, {useState} from 'react'
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { GridMoreVertIcon } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';
import EmailIcon from '@mui/icons-material/Email';
import GroupsIcon from '@mui/icons-material/Groups';
import axios from 'axios';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      }
    },
  },
}));

export default function CustomizedMenus(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const [userRole, setUserRole] = useState(localStorage.getItem("userrole"));

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDelete =()=>{
    handleClose();
    props.handleDeleteClick();
  }

  const handleNotification=()=>{
    handleClose();
    props.handleNotificationClick();
  }

  const handleEmail=()=>{
    handleClose();
    props.handleEmailClick();
  }

const handleGroupReportClick=()=>{
  handleClose();
  props.handleGroupReportClick();
}

const handleImportCompanies=()=>{
  handleClose();
  props.handleImportCompanies();
}

const handleImportUsers=()=>{
  handleClose();
  props.handleImportUsers();
}

const handleImportSituations=()=>{
  handleClose();
  props.handleImportSituations();
}

const handleSendAssessmentToAll=()=>{
  handleClose();
  props.handleSendAssessmentToAll();
}

const downloadExcel=(fileName)=>{
  axios.get('/excels/' + fileName)
        .then(function (response) {
          
        })
        .catch(function (error) {
          props.setErrors(error.message);
        });

        axios({
          url: '/excels/' + fileName, //your url
          method: 'GET',
          responseType: 'blob', // important
      }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName); //or any other extension
          document.body.appendChild(link);
          link.click();
      });
}

const handleSelectedDownloads=()=>{
  props.handleSelectedDownloads();
}

const handleResendAssessmentClick=()=>{
  props.handleResendAssessmentClick();
}

const handleDownloadTrainingTextClick=()=> {
  props.handleDownloadTrainingTextClick();
}

  return (
    <div>
      <Button
        id="demo-customized-button"
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
        endIcon={<GridMoreVertIcon />}
      >
        Options
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        { userRole == "Admin" && props.modulename != "Assessments" && <MenuItem onClick={handleDelete} disableRipple>
          <DeleteIcon />
          Delete
        </MenuItem>
        }

        {props.modulename == 'Companies' ?
          <MenuItem disableRipple onClick={()=>{ downloadExcel("CompanyTemplate.xlsx")}}>
          <FileCopyIcon/>
          Download template
          </MenuItem>
          : ""
        }
        {props.modulename == 'Companies' ?
          <MenuItem onClick={handleImportCompanies} disableRipple>
          <FileCopyIcon/>
            Import
          </MenuItem>
          : ""
        }
        {props.modulename == 'Users' ?
          <MenuItem disableRipple onClick={()=>{ downloadExcel("UserTemplate.xlsx")}}>
          <FileCopyIcon/>
          Download template
          </MenuItem>
          : ""
        }
        {props.modulename == 'Users' ?
          <MenuItem onClick={handleImportUsers} disableRipple>
          <FileCopyIcon/>
            Import
          </MenuItem>
          : ""
        }
        {/* {props.modulename == 'Situations' ?
          <MenuItem disableRipple onClick={()=>{ downloadExcel("SituationsTemplate.xlsx")}}>
          <FileCopyIcon/>
          Download template
          </MenuItem>
          : ""
        }
        {props.modulename == 'Situations' ?
          <MenuItem onClick={handleImportSituations} disableRipple>
          <FileCopyIcon/>
            Import
          </MenuItem>
          : ""
        } */}
        {props.modulename == 'Companies' || props.modulename == 'Users' ?
          <MenuItem onClick={handleNotification} disableRipple>
          <EmailIcon/>
            Send New Assessment
          </MenuItem>
          : ""
        }
        {props.modulename == "Users" ?
        <MenuItem onClick={handleSendAssessmentToAll} disableRipple>
        <EmailIcon/>
          Send Assessment to All
        </MenuItem>
        : ""
        }
        {props.modulename == 'Assessments' ?
          <MenuItem onClick={handleEmail} disableRipple>
          <EmailIcon/>
            Email Report
          </MenuItem>
          : ""
        }
        {props.modulename == 'Assessments' ?
          <MenuItem onClick={handleSelectedDownloads} disableRipple>
          <FileCopyIcon/>
            Download reports
          </MenuItem>
          : ""
        }
        {props.modulename == 'Assessments' ?
          <MenuItem onClick={handleGroupReportClick} disableRipple>
          <GroupsIcon/>
            Generate Group Report
          </MenuItem>
          : ""
        }
        {props.modulename == 'Assessments' ?
          <MenuItem onClick={handleResendAssessmentClick} disableRipple>
          <EmailIcon/>
            Re-send Assessment
          </MenuItem>
          : ""
        }
         {props.modulename == 'Training' ?
          <MenuItem onClick={handleDownloadTrainingTextClick} disableRipple>
           <FileCopyIcon/>
            Download training text
          </MenuItem>
          : ""
        }
        
      </StyledMenu>
    </div>
  );
}

